/*
 * Feed Question Module
 *
 * Description:
 * Module that handles events related to questions
 *
 * Purpose: 
 * This module helps divide big feed module into smaller components
 *
 * @authors: Chiran Doshi and Elton Jain
 */

define('FeedQuestions',[
	'jquery',
	'Auth',
	'Groups',
	'modules/common/Constants',
	'Config',
	'JSTemplate',
	'UI'
], function($, Auth, Groups, Constants, Config, template, UI) {
	'use strict';

	var o,
		defaults = {
			feedContainerId: 'feed',
			apiLike: 'ajax/question/like',
			apiUnlike: 'ajax/question/unlike',
			eleAnswerFormClass: '.form-post-answer',
			txtAnswerInputClass: '.inp-answer-text',
			similarQsApiData: {
				type: 'topic'
			}
		},
		langs = Config.get('lang'),
		isDetailPage = false,
		$elFeedContainerId,
		userData = Auth.getUser(),
		FLAG_QUESTION_PAGE_OPEN = false,

		updateLikeCount = function($btn, isLiked) {
			// Update Like count
			var $eleLikeCount = $btn.find('.lbl-like-count');

			if (isLiked === true) {
				$btn.removeClass('active');
				$eleLikeCount.html(parseInt($eleLikeCount.html()) - 1);
			} else {
				$btn.addClass('active');
				$eleLikeCount.html(parseInt($eleLikeCount.html()) + 1);
			}
		},

		_likeQuestion = function(questionId, doLike, callback) {
			var base = this,
				api = (doLike === false) ? o.apiUnlike : o.apiLike;

			if (!Auth.checkLoginRequired({source: 'feed question like'})) {
				return false;
			}

			$.post(api, {
				questionId: questionId
			}, function(response) {

				if (response.status === true) {

					if (callback) {
						callback();
					} else {
						alert('You\'ve liked this question');
					}

				} else if (response.status === false) {

					// Decrease Like count
					if (response.status_code === Constants.status_code.no_auth_login) {
						Auth.showLoginPopup(true, {source: 'feed question like'});
					} else if (response.status_code === Constants.status_code.no_auth_group) {
						alert('You need to join this group to like this post');
					} else {
						alert(response.message);
					}
				}
			});

		},

		_bindEvents = function() {

			// on Click of Reply
			UI.$b.on('click', '.feed-post .btn-q-answer', function(e) {
				if (!Auth.checkLoginRequired({source: 'feed answer btn'})) {
					return false;
				}
				var $btn = $(this),
					$eleFeedPost = $btn.parents('.feed-post'),
					$answerForm = $eleFeedPost.find(o.eleAnswerFormClass),
					qUrl = $btn.attr('href'),
					questionId = $btn.data('q');

				if((FLAG_QUESTION_PAGE_OPEN === true && $answerForm.length > 0) || isDetailPage) {
					$answerForm.removeClass('hidden');
					$answerForm.find(o.txtAnswerInputClass).height(50).focus();
				}
				else {
					if((Auth.getUser().is_verified || Auth.getUser().admin_role !== null) && $(e.target).hasClass('btn-q-answer')) {
						if($('#form-answer-' + questionId).length === 0) {
							var html = template('tplAnswerForm',{
							isDetailPage: false,
							questionId: questionId,
							langs: langs
						});
						$eleFeedPost.append(html);	
					} else {
						$('#form-answer-' + questionId).removeClass('hidden');
					}
						
					} else {
						var options = {
							reply: true
						};
						showQuestionPage(questionId, options);
						return false;
					}
				}

				// window.location.href = qUrl;

				return false;
			});

			// Follow
			var qFollowFlags = {};
			UI.$b.on('click', '.feed-post .btn-q-follow', function() {
				if (!Auth.checkLoginRequired({source: 'follow question'})) {
					return false;
				}
				var questionId = $(this).data('q'),
					questionData = window._gtap.data.f[questionId],
					$btn = $('.btn-q-follow[data-q='+questionId+']'),
					isFollowing = $btn.is('.active') ? true : false,
					action = isFollowing ? 'question_unfollow' : 'question_follow';

				if(qFollowFlags[questionId] === true) {
					return false;
				}
				qFollowFlags[questionId] = true;
				
				$btn.toggleClass('active');

				require(['modules/Feed/FeedAction'], function (FeedAction) {
					var fa = new FeedAction('question'),
						apiData = {
							questionId: questionId,
							userId: Auth.getUser().id
						},
						mixpanelData = {
							question_id: questionId
						};
						
					require(['Mixpanel'], function(MixPanel) {
						MixPanel.hit(action, mixpanelData);
					});

					fa.callAction(action, apiData, function () {
						qFollowFlags[questionId] = false;
					});
					if(questionData) {
						questionData.actions.unfollow = !isFollowing;
						questionData.actions.follow = isFollowing;
					}
				});
				return false;
			});

			// Like
			UI.$b.on('click', '.feed-post .btn-q-like', function(ev) {
				if (!Auth.checkLoginRequired({source: 'feed question like'})) {
					return false;
				}
				
				if($(ev.target).hasClass('itm-action-count')) {
					return;
				}

				var questionId = $(this).data('q'),
					$btn = $('.btn-q-like[data-q='+questionId+']'), //$(this),
					$elCounter = $btn.children('.itm-action-count'),
					questionData = window._gtap.data.f[questionId],
					isLiked = $btn.is('.active') ? true : false,
					mixpanelData = {},
					count = questionData.likes.count;

				mixpanelData = {
					'question_id': questionId,
					'user': userData.fullname,
					'user_id': userData.id
				};

				if(isLiked) {
					// Unlike
					$elCounter.text(--count);
					$btn.removeClass('active');
					if(!count >= 1) {
						$elCounter.addClass('hidden');
					}
				} else {
					// Like
					$elCounter.text(++count);
					if(count >= 1) {	
						$elCounter.removeClass('hidden');
					}
					$btn.addClass('active');
				}

				if(questionData) {
					questionData.likes.liked = !isLiked;
					questionData.likes.count = count;
				}

				_likeQuestion(questionId, !isLiked, function() {
					if (!isLiked) {
						require(['Mixpanel'], function(MixPanel) {
							MixPanel.hit('question_like', mixpanelData);
						});
					}
				});

				return false;
			});

			// Expand read-more video description
			UI.$b.on('click', '.feed-video-parent .btn-expand', function (e) {
				e.preventDefault();
				var descriptionEl = $(this).closest('.description'),
					descriptionText = descriptionEl.data('description');
				descriptionEl.text(descriptionText);
			});


			// Expand read-more question
			UI.$b.on('click', '.feed-post .q-text .btn-expand', function (e) {
				e.preventDefault();
				var $btn = $(this),
					$elText = $btn.parent('.q-text'),
					qId = $btn.data('q'),
					question = window._gtap.data.f[qId];

				require(['Helper'], function (Helper) {
					if(question) {
						$btn.remove();
						$elText.html(Helper.nl2br(question.topic.message));
						Helper.linkifyFeedContent($elText);
					}
				});
				return false;
			});


			// On click of text, navigate to page
			if (!isDetailPage) {
				UI.$b.on('click', '.feed-post .q-text, .feed-post .btn-more-answers', function(e) {
					if($(e.target).is('.linkified')) {
						return;
					}
					var questionId = $(this).parents('.feed-post').data('id');
					if(!FLAG_QUESTION_PAGE_OPEN && questionId) {

						// Mixpanel track click
						// and if question has verified icon
						showQuestionPage(questionId);
						require(['Mixpanel'], function (MixPanel) {
							MixPanel.hit('click', {
			                    target: (e.target.className === 'q-text' ? 'feed q text' : 'feed q more'),
								has_verified_icon: window._gtap.data.f[questionId].topic.expert_reply_count || 0
		                	});
						});
						return false;
					}
				});
			}

			// if (!Auth.check() && isDetailPage) {
			// 	UI.$b.on('click', '.feed-post .btn-more-answers', function(e) {
			// 		console.log('btn more answer');
			// 		if (!Auth.checkLoginRequired()) {
			// 			return false;
			// 		}	
			// 	});
			// }
		},

		/**
		 * Show Question Detail Page Overlay
		 * @param  {[int]} questionId [description]
		 * @param  {[array]} options    [reply: true|false, ]
		 * @return false
		 */
		showQuestionPage = function (questionId, options) {
			var base = this;
			if(!questionId) {return true;} // So normal redirect can work
			var questionData = window._gtap.data.f[questionId];
			if(!questionData) {
				$.post('/ajax/question', {questionId: questionId}, function (response) {
					questionData = response.response;
					questionData.replies = [];
					window._gtap.data.f[questionData.topic.id] = questionData;
				}).done(function () {
					doStuff();
				});
				return false;
			} else {
				doStuff();
				return false;
			}

			function doStuff () {
				o.similarQsApiData.q = questionData.topic.message;
				o.similarQsApiData.topicId = questionData.topic.id;

				require(['JSTemplate', 'Helper', 'History', 'FeedAnswers'], function (template, Helper, History, FeedAnswers) {
					window._gtap.settings.page.isDetailPage = true;
					var feedTemplate = 'tplFeedList',
						elQuestionPageId = 'app-page-answer',
						tmplData = {
							topics: {feed : [questionData]},
		                    User: Auth.getUser(),
		                    isDetailPage: true,
		                    page: 1,
		                    isPopup: true,
		                    modules: {
		                    	Auth: Auth,
		                    	Config: Config,
		                    	Helper: Helper
		                    },
		                    cookie_fn: $.cookie
						},
						qPageHtml = template(feedTemplate, tmplData),
	                	$elAnswerPage = $('<div>'),
	                	$elCommentForm,
	                	ansHtml = template('tplAnswerForm',{
	                		isDetailPage: true,
                			questionId: questionData.topic.id,
                			langs: Config.get('lang')
	                	});

	                $elAnswerPage.attr('id', elQuestionPageId).addClass(elQuestionPageId).attr('data-q', questionId);
	                $elAnswerPage.append(qPageHtml);
	                UI.$b.append(ansHtml);
	                FLAG_QUESTION_PAGE_OPEN = true;
	                UI.noscroll();
	                UI.$b.append($elAnswerPage);
	                UI.showBackButton();
	                isDetailPage = true;
	                $elCommentForm = $elAnswerPage.find('.form-post-answer');
	                $elCommentForm.addClass('loading');

	                // Lazy load question image
	                Helper.loadFeedImages($elAnswerPage);
	                Helper.linkifyFeedContent($elAnswerPage.find('.q-text'));

	                if(ga) {
	                	ga('set','page',questionData.topic.url);
	                	ga('send','pageview');
	                }

	                History.pushState({
		                url: questionData.topic.url,
		                popupId: elQuestionPageId,
		                removeEl: true,
		                isPage: true,
		                callback: function (items) {

		                	$('.form-post-answer-wrap').remove();

		                	FLAG_QUESTION_PAGE_OPEN = false;
			                UI.noscroll(false);
			                window._gtap.settings.page.isDetailPage = false;
			                isDetailPage = false;
			                if(items && items.length > 0 && items[items.length - 1].isPage === true) {
		                        UI.showBackButton(true);
		                    } else {
		                        UI.showBackButton(false);
		                    }
		                    
		                    if(ga) {
			                	ga('set','page',window.location.pathname);
			                	ga('send','pageview');
			                }
		                }
		            });
		            FeedAnswers.getAnswers({
		            	page: 1,
		            	questionId: questionId,
		            	callback: function (response) {
		            		if(response.status === true) {
			            		var tmplData = {
			                		isDetailPage: true,
			                		questionId: questionId,
			                		answers: response.response,
			                		page: 1,
			                		modules: {
			                			Auth: Auth,
	                    				Config: Config,
	                    				Helper: Helper
			                		}
			                	};
			                	var html =  template('tplAnswerList', tmplData);
			                	$elAnswerPage.find('.post-answers').html(html);
			                	$elCommentForm.removeClass('loading');

			                	setTimeout(function () {
			                		Helper.linkifyFeedContent($elAnswerPage.find('.cmt-text'));
			                	}, 50);

			                	if(response.response.similar) {
				                	var html =  template('tplSimilarQuestions', {
										data: response.response.similar,
										langs: langs
									});
									$('#feed-answers-' + o.similarQsApiData.topicId).after(html); // Append after answers
								}
			                }
			                //_fetchSimilarQuestions();
		            	}
		            });

		            require(['Mixpanel'], function(MixPanel) {
			            MixPanel.hit('visit_page', {
		                    'page': 'Question Page',
		                    'content_id': questionId
		                });
		            });
		            require(['autosize'], function(autosize) {
			            autosize($elCommentForm.find('.autogrow'));
			        });

		            if(options && options.reply === true) {
		            	setTimeout(function () {
			            	$elAnswerPage.find(o.txtAnswerInputClass).trigger('focus');
			            }, 1500);
		            }
		            if(options && options.callback) {
		            	options.callback();
		            }
	            });
	        }

			return false;
		},

		_fetchSimilarQuestions = function() {
			var api = '/ajax/similarquestions';
			o.similarQsApiData.questionId = o.similarQsApiData.topicId;

			$.post(api,o.similarQsApiData,function(response) {
				if(response.status == true && response.response.length > 0) {
					var html =  template('tplSimilarQuestions', {
						data: response.response,
						langs: langs
					});
					$('#feed-answers-' + o.similarQsApiData.topicId).after(html); // Append after answers
				}
			});
		},

		init = function(options) {
			o = $.extend(defaults, options);
			$elFeedContainerId = $('#' + o.feedContainerId);
			isDetailPage = (Config.get('page.route') === 'topic' || Config.get('page.route') === 'poll') ?  true : false;
			_bindEvents();
			if(Config.get('page.route') === 'topic' || Config.get('page.route') === 'poll') {
				for(var first in window._gtap.data.f) {
					o.similarQsApiData.q = window._gtap.data.f[first].topic.message;
					o.similarQsApiData.topicId = window._gtap.data.f[first].topic.id;
					//_fetchSimilarQuestions();
					break;
				}
			}
		};

	return {
		init: init,
		updateLikeCount: updateLikeCount,
		showQuestionPage: showQuestionPage
	};
});
